module.exports = __webpack_public_path__ + "static/media/commentRota.d1efe99f.svg";